import { OrganizationKeyName } from "../../../../model/Organization";
import { UserVoucherListItem } from "../../model/GetUserVoucherListSuccessResponse";

export const GET_USER_VOUCHER_LIST_SUCCESS =
  "SHOP:GET_USER_VOUCHER_LIST_SUCCESS";

export const getUserVoucherListSuccessAction = (
  organization: OrganizationKeyName,
  userId: string,
  data: UserVoucherListItem[]
) => ({
  type: GET_USER_VOUCHER_LIST_SUCCESS as typeof GET_USER_VOUCHER_LIST_SUCCESS,
  organization,
  userId,
  data,
});

export type GetUserVoucherListSuccessAction = ReturnType<
  typeof getUserVoucherListSuccessAction
>;
